import React from 'react'
import PropTypes from 'prop-types'
import { Button, IconButton } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import SearchIcon from '@material-ui/icons/Search'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import buttonBackHeaderStyles from './css/buttonBackHeaderStyles'

const ButtonBackHeader = ({ buttonText, onActionButtonClick, icon, disableActionButton }) => {
  const classes = buttonBackHeaderStyles()
  const history = useHistory()

  const showIcon = () => {
    switch (icon) {
      case 'search':
        return <SearchIcon />
      case 'arrowRight':
        return <ArrowForwardIosIcon />
      default:
        return null
    }
  }

  return (
    <div className={classes.headerContainer}>
      <IconButton
        className={classes.iconButton}
        onClick={() => {
          history.goBack()
        }}
      >
        <KeyboardBackspaceIcon />
      </IconButton>

      <Button
        disabled={disableActionButton}
        size="large"
        variant="contained"
        color="primary"
        endIcon={showIcon()}
        type="submit"
        className={classes.button}
        onClick={onActionButtonClick}
      >
        {buttonText}
      </Button>
    </div>
  )
}

ButtonBackHeader.propTypes = {
  buttonText: PropTypes.string,
  onActionButtonClick: PropTypes.func,
  icon: PropTypes.string,
  disableActionButton: PropTypes.bool,
}

ButtonBackHeader.defaultProps = {
  buttonText: '',
  onActionButtonClick: () => {},
  icon: '',
  disableActionButton: false,
}

export default ButtonBackHeader
